let businessFlow=[
    { title: "1、签约注册：", desc: "客户与普拉托签订《普托邦会员服务协议》，并在普拉托运营的“普托e享”专用系统注册账号，用于业务操作。" },
    { title: "2、平价采购：", desc: "客户通过普拉托平价采购指定标准托盘，采购价款支付成功即认购完成。" },
    { title: "3、委托管理：", desc: "客户把平价采购获得的指定标准托盘委托给普拉托统一运营、维护管理，投入普拉托管理的托盘池进行循环共享，客户也可根据自身需求，提取托盘供自身使用。" },
    { title: "4、残值处置：", desc: "客户可针对其持有并委托的托盘向普拉托提出残值回购申请，普拉托将按协议约定的残值回购率进行回购。" }
],
//托盘共享费用说明
chargeDesc = [
    { title: "1、托管费", desc: '指普拉托受托管理托盘资产，并为客户提供托盘托管、维护，登记、共享收益清算、残值转让服务而收取的管理服务费；托管费按年度收取，不足1年，按1年收取。' },
    { title: "2、上门统一配送回收费", desc: "会员存续期内客户要求普拉托提供上门配送回收服务的，在普拉托服务范围内，普拉托平台统一按约定收取上门配送回收物流服务费。" },
    { title: "3、其他费用", desc: "客户因设备提取业务产生的租赁相关费用，包括但不限于押金、租费、清洗费等。" }
]



 export {businessFlow,chargeDesc}